"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValueAccordingToLanguage = exports.getLanguageFlag = exports.countryToLocale = void 0;
var flagMap = {
  en: 'gb'
};
var countryMap = {
  gb: 'en'
};
var getLanguageFlag = function getLanguageFlag(locale) {
  return flagMap[locale] || locale;
};
exports.getLanguageFlag = getLanguageFlag;
var countryToLocale = function countryToLocale(locale) {
  return countryMap[locale] || locale;
};
exports.countryToLocale = countryToLocale;
var getValueAccordingToLanguage = function getValueAccordingToLanguage(lang) {
  return countryToLocale(lang);
};
exports.getValueAccordingToLanguage = getValueAccordingToLanguage;